import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { CheckCircle2, XCircle, CircleDot } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

const UnsubscribeLanding = () => {
  const [searchParams] = useSearchParams()
  const hasError = searchParams.get('error') === 'invalid'

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 mb-4">
            <CircleDot className="h-6 w-6 text-primary" />
          </div>
        </div>
        <Card className="border border-border shadow-sm">
          <CardContent className="pt-6 flex flex-col items-center text-center gap-3">
            {hasError ? (
              <>
                <XCircle className="h-10 w-10 text-destructive" />
                <h1 className="text-xl font-semibold">Link expired or invalid</h1>
                <p className="text-sm text-muted-foreground">
                  This unsubscribe link is no longer valid. If you're still receiving unwanted emails, please contact us directly.
                </p>
              </>
            ) : (
              <>
                <CheckCircle2 className="h-10 w-10 text-emerald-600" />
                <h1 className="text-xl font-semibold">You've been unsubscribed</h1>
                <p className="text-sm text-muted-foreground">
                  You won't receive any more marketing emails from us. It may take a few minutes to take effect.
                </p>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default UnsubscribeLanding
